
import '../App.css';

const Statistics = (props) => {
  const { data } = props;

  return (
    <div className="card statistics">
      <h3 className="card-title">气象统计</h3>
      {data && (
        <div className="statistics-list">
          <div className="item">
            <p className="value">{data.o_temp} ℃</p>
            <span className="label">温度</span>
          </div>
          <div className="item">
            <p className="value">{data.o_hum} RH</p>
            <span className="label">湿度</span>
          </div>
          <div className="item">
            <p className="value">{data.o_sun} Lux</p>
            <span className="label">光照度</span>
          </div>
          <div className="item">
            <p className="value">{data.o_windSpeed} m/s</p>
            <span className="label">风速</span>
          </div>
          <div className="item">
            <p className="value">{data.o_windAngle}</p>
            <span className="label">风向</span>
          </div>
        </div>
      )}
    </div>
  );
}

export default Statistics;
